export default __webpack_public_path__ + "static/media/topicMinting.0db0e302.png";